export const PurchaseInfoContentPurchaseType = {
  Bought: 'BOUGHT',
  Rented: 'RENTED',
  RentedUnlimited: 'RENTED_UNLIMITED',
} as const
export type PurchaseInfoContentPurchaseType =
  (typeof PurchaseInfoContentPurchaseType)[keyof typeof PurchaseInfoContentPurchaseType]

export interface PurchaseInfo {
  contentPurchaseType?: PurchaseInfoContentPurchaseType
  /**
   * DateTime in UTC until content is rented
   */
  rentedUntil?: string
}
